import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
var RouterPlugin = function RouterPlugin() {
  this.$router = null;
  this.$store = null;
};
RouterPlugin.install = function (router, store) {
  var _this = this;
  this.$router = router;
  this.$store = store;
  function isURL(s) {
    if (s.includes('html')) return true;
    return /^http[s]?:\/\/.*/.test(s);
  }
  function objToform(obj) {
    var result = [];
    Object.keys(obj).forEach(function (ele) {
      result.push("".concat(ele, "=").concat(obj[ele]));
    });
    return result.join('&');
  }
  this.$router.$avueRouter = {
    //全局配置
    $website: this.$store.getters.website,
    $defaultTitle: '爱宠帮',
    routerList: [],
    group: '',
    meta: {},
    safe: this,
    // 设置标题
    setTitle: function setTitle(title) {
      title = title ? "".concat(title, "\u2014\u2014").concat(this.$defaultTitle) : this.$defaultTitle;
      document.title = title;
    },
    closeTag: function closeTag(value) {
      var tag = value || _this.$store.getters.tag;
      if (typeof value === 'string') {
        tag = _this.$store.getters.tagList.filter(function (ele) {
          return ele.value === value;
        })[0];
      }
      _this.$store.commit('DEL_TAG', tag);
    },
    //处理路由
    getPath: function getPath() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var src = params.src;
      var result = src || '/';
      if (isURL(src)) {
        result = "/myiframe/urlPath?".concat(objToform(Object.assign(meta, params)));
      }
      return result;
    },
    //正则处理路由
    vaildPath: function vaildPath(list, path) {
      var result = false;
      list.forEach(function (ele) {
        if (new RegExp("^" + ele + ".*", "g").test(path)) {
          result = true;
        }
      });
      return result;
    },
    //设置路由值
    getValue: function getValue(route) {
      var value = "";
      if (route.query.src) {
        value = route.query.src;
      } else {
        value = route.path;
      }
      return value;
    },
    //动态路由
    formatRoutes: function formatRoutes() {
      var _this2 = this;
      var aMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var first = arguments.length > 1 ? arguments[1] : undefined;
      var aRouter = [];
      var propsConfig = this.$website.menu.props;
      var propsDefault = {
        label: propsConfig.label || 'label',
        path: propsConfig.path || 'path',
        icon: propsConfig.icon || 'icon',
        children: propsConfig.children || 'children',
        meta: propsConfig.meta || 'meta'
      };
      if (aMenu.length === 0) return;
      var _loop = function _loop() {
        var oMenu = aMenu[i];
        var path = function () {
            if (first) {
              return oMenu[propsDefault.path].replace('/index', '');
            } else {
              return oMenu[propsDefault.path];
            }
          }(),
          _component = oMenu.component,
          name = oMenu[propsDefault.label],
          icon = oMenu[propsDefault.icon],
          children = oMenu[propsDefault.children],
          meta = oMenu[propsDefault.meta] || {};
        meta = {
          keepAlive: Number(oMenu['keepAlive']) === 0
        };
        var isChild = children && children.length !== 0;
        var oRouter = {
          path: path,
          component: function component(resolve) {
            // 判断是否为首路由
            if (first) {
              require(['../page/index'], resolve);
              return;
              // 判断是否为多层路由
            } else if (isChild && !first) {
              require(['../page/index/layout'], resolve);
              return;
              // 判断是否为最终的页面视图
            } else {
              require(["../".concat(_component, ".vue")], resolve);
            }
          },
          name: name,
          icon: icon,
          meta: meta,
          redirect: function () {
            if (!isChild && first && !isURL(path)) return "".concat(path, "/index");else return '';
          }(),
          // 处理是否为一级路由
          children: !isChild ? function () {
            if (first) {
              if (!isURL(path)) oMenu[propsDefault.path] = "".concat(path, "/index");
              return [{
                component: function component(resolve) {
                  require(["../".concat(_component, ".vue")], resolve);
                },
                icon: icon,
                name: name,
                meta: meta,
                path: 'index'
              }];
            }
            return [];
          }() : function () {
            return _this2.formatRoutes(children, false);
          }()
        };
        aRouter.push(oRouter);
      };
      for (var i = 0; i < aMenu.length; i++) {
        _loop();
      }
      if (first) {
        this.safe.$router.addRoutes(aRouter);
      } else {
        return aRouter;
      }
    }
  };
};
export default RouterPlugin;